import { SESSION_OVERRIDE_KEY } from "@/features/client-config/contexts/unit/constants";
import { LANGUAGE_STORAGE_KEY } from "@/services/i18n/types";
import { LAST_APP_OPEN_KEY } from "@/services/monitoring/startup-metrics/constants";

const KNOWN_LOCAL_STORAGE_KEYS = [
  LANGUAGE_STORAGE_KEY,
  SESSION_OVERRIDE_KEY,
  LAST_APP_OPEN_KEY,
];

export type ClearWebStorageEnv = {
  getLocalStorage: () => Pick<Storage, "removeItem">;
  getSessionStorage: () => Pick<Storage, "clear">;
};

const defaultEnv: ClearWebStorageEnv = {
  getLocalStorage: () => localStorage,
  getSessionStorage: () => sessionStorage,
};

/**
 * Clears every known localStorage preference key plus all of sessionStorage,
 * so a factory/full reset actually returns the device to first-install
 * defaults instead of leaving stale preferences behind.
 */
export function clearWebStorage(env: ClearWebStorageEnv = defaultEnv): void {
  try {
    const localStorageRef = env.getLocalStorage();
    for (const key of KNOWN_LOCAL_STORAGE_KEYS) {
      localStorageRef.removeItem(key);
    }
  } catch (error) {
    console.error("Failed to clear localStorage:", error);
  }

  try {
    env.getSessionStorage().clear();
  } catch (error) {
    console.error("Failed to clear sessionStorage:", error);
  }
}
